import { fileService } from '../services/file.service';
import { fileConstants } from '../constants/file.constants';
import { alertsActions } from './alerts.actions';
import getErrorMessage from '../../utils/getErrorMessage';

/**
 * note: the api won't wait until finished uploaded to be "Done"
 * frontend has to reload the ticket and check the attachments part if the attachment is "Done"
 * @param file
 * @param newName
 * @param ticketId
 */
const upload = (file: File, newName: string, ticketId: string) => {
  // not sure if need to store any param when request

  console.warn(
    'file is passed but not storing in the store. note: cannot store file in the store',
    file,
  );
  const request = () => {
    return {
      type: fileConstants.FILE_UPLOAD_REQUEST,
      // // note sending these params for now
      payload: { newName },
      //   ticketId,
    };
  };

  const failure = (error) => {
    return {
      type: fileConstants.FILE_UPLOAD_ERROR,
      payload: { newName, error },
    };
  };

  return async (dispatch) => {
    dispatch(request());
    try {
      await fileService.uploadFile(file, newName, ticketId);
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      dispatch(failure(errorMessage as string));
      dispatch(alertsActions.error(errorMessage));
    }
  };
};

const uploadSuccess = (newNames: string[]) => {
  return {
    type: fileConstants.FILE_UPLOAD_SUCCESS,
    payload: { newNames },
    // data:  camelcaseKeys(data, { deep: true }), // data. seems like
  };
};

/**
 * for the failed file, do not call api
 * @param index
 */
const deleteLocalAtIndex = (index) => {
  return {
    type: fileConstants.FILE_DELETE_LOCAL_AT_INDEX,
    payload: { index },
  };
};

/**
 * for the failed file, do not call api
 * @param index
 */
const deleteLocalAtIndexes = (indexes: number[]) => {
  return {
    type: fileConstants.FILE_DELETE_LOCAL_AT_INDEXES,
    payload: { indexes },
  };
};

export const fileActions = {
  upload,
  uploadSuccess,
  deleteLocalAtIndex,
  deleteLocalAtIndexes,
};
